import { render, staticRenderFns } from "./NaverpayConfigIframe.vue?vue&type=template&id=6079b013&"
import script from "./NaverpayConfigIframe.vue?vue&type=script&lang=ts&"
export * from "./NaverpayConfigIframe.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports